import React from 'react';
import { useIntl } from 'react-intl-next';
import { PrimaryButton } from '@atlaskit/atlassian-navigation';
import { ChatPillIcon } from '../../common/ui/chat-icon';
import { messages } from './messages';
export const ConversationAssistantButton = ({
  testId,
  isActive,
  onClick,
  tooltipContent
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(PrimaryButton, {
    style: {
      paddingInline: '8px'
    },
    iconBefore: /*#__PURE__*/React.createElement(ChatPillIcon, null),
    testId: testId,
    isSelected: isActive,
    onClick: onClick,
    tooltip: tooltipContent !== null && tooltipContent !== void 0 ? tooltipContent : formatMessage(messages.buttonLabel)
  }, formatMessage(messages.buttonLabel));
};